import { call, fork, takeEvery } from 'redux-saga/effects';
import { fetchTeamResumeStats } from '../api'
import { teamResumeStatsActions } from './actions';


export function* loadTeamResumeStats({ payload }) {
    const { team_id } = payload;

    yield call(fetchTeamResumeStats, team_id);
}


export function* watchLoadTeamResumeStats() {
    yield takeEvery(teamResumeStatsActions.LOAD_TEAM_RESUME_STATS, loadTeamResumeStats);
}


export const teamResumeStatsSagas = [
    fork(watchLoadTeamResumeStats)
];
